import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    findTodayPublishInfo: host + 'analysis/findTodayPublishInfo',//今日发布信息统计
    find7DaysPublishCount: host + 'analysis/find7DaysPublishCount', //近七日发文量统计
    findFansCountNow: host + 'analysis/findFansCountNow', //新媒体粉丝数统计
    findWx7DaysFansVariation: host + 'analysis/findWx7DaysFansVariation', //粉丝增减趋势
    findHotStorysByMeidaType: host + 'analysis/findHotStorysByMeidaType' , //热文排行
   
};

export const findTodayPublishInfo = (body, callBack) => {  //今日发布信息统计
    request({url:Apis.findTodayPublishInfo, body, callBack});
}

export const find7DaysPublishCount = (body, callBack) => { //近七日发文量统计
    request({url:Apis.find7DaysPublishCount, body, callBack});
}

export const findFansCountNow = (body, callBack) => {  //新媒体粉丝数统计
    request({url:Apis.findFansCountNow, body, callBack});
}

export const findWx7DaysFansVariation = (body, callBack) => {  //粉丝增减趋势
    request({url:Apis.findWx7DaysFansVariation, body, callBack});
}

export const findHotStorysByMeidaType = (body, callBack) => { //热文排行
    request({url:Apis.findHotStorysByMeidaType, body, callBack});
}